import { RootState } from "app/rootReducer";
import { useSelector } from "react-redux";

const useAppLoading = () => useSelector((state: RootState) => state.appLoading);

export { useAppLoading };
